import { AsyncPipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, inject, LOCALE_ID, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ClickEvent, HoverRatingChangeEvent, RatingChangeEvent } from 'angular-star-rating';
import { FormWarranty } from '@web-nx-ng-tsc/tirewarranty-shared-data-access';

import { catchError, map, Observable, startWith, throwError } from 'rxjs';
import { ConditionWarrantyComponent } from '../../condition-warranty/condition-warranty.component';
import { PolicyDialogComponent } from '../../policy-dialog/policy-dialog.component';
import { SuccessComponent } from '../../success/success.component';
import { ValidDialogComponent } from '../../valid-dialog/valid-dialog.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormApiService } from '@web-nx-ng-tsc/tirewarranty-shared-data-access';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { StarRatingModule } from 'angular-star-rating';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ConditionWarrantyAdvanceComponent } from '../../condition-warranty-advance/condition-warranty-advance.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatButtonModule,
    StarRatingModule,
    MatDialogModule,
    MatTooltipModule,
    MatSelectModule,
    MatAutocompleteModule,
    AsyncPipe,
  ],
  providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent implements OnInit {
  private readonly loggingService = inject(LoggingService);

  title = 'ssg-tw-grip';
  today = new Date();
  // formGroup!: FormGroup; // Declare the FormGroup property

  allowOnlyNumbers(event: KeyboardEvent) {
    const pattern = /^[0-9]$/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  }
  // checkPatternPhone = false;
  validatePostalCode() {
    const value = this.form.PostalCar || ''; // Handle undefined/null value
    const sanitizedValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    this.form.PostalCar = sanitizedValue;

    // Update form control validity
    if (/^\d{5}$/.test(sanitizedValue)) {
      this.postalCarFormControl.setErrors(null); // Valid postal code
    } else {
      this.postalCarFormControl.setErrors({ invalid: true }); // Invalid postal code
    }
  }
  validatePhoneNumber() {
    const value = this.form.tel;
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    this.form.tel = sanitizedValue;

    // Update form control validity
    if (/^\d{10}$/.test(sanitizedValue)) {
      this.telFormControl.setErrors(null); // Valid phone number
    } else {
      this.telFormControl.setErrors({ invalid: true }); // Invalid phone number
    }
  }
  checkPatternEmail = false;
  validateEmail() {
    const value = this.form.email.trim();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // ถ้ามีการกรอกและแพทเทิร์นไม่ถูกต้อง ให้แสดงข้อผิดพลาด
    this.checkPatternEmail = (value !== '' || value !== null) && !emailPattern.test(value);
    this.loggingService.log('this.checkPatternEmail', this.checkPatternEmail);
  }
  allowEnglishAndSpecialChars(event: KeyboardEvent) {
    const allowedCharsRegex = /^[a-zA-Z0-9@._\-+]+$/;
    // const allowedCharsRegex = /^[a-zA-Z0-9#\$%\^&\*\(\)@._%+\-]$/;
    if (!allowedCharsRegex.test(event.key)) {
      event.preventDefault(); // Block invalid input
    }
  }
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private fb: FormBuilder,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    // this.formGroup = this.fb.group({
    //   // firstNameFormcontrol: ['', [Validators.required]], // Control with required validation
    //   // lastNameFormcontrol: ['', [Validators.required]],  // Control with required validation
    //   // stelFormControl: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]], // Phone number validation
    //   firstNameFormcontrol : new FormControl('', [Validators.required]),
    //   lastNameFormcontrol : new FormControl('', [Validators.required]),
    //   genderFormControl : new FormControl('ชาย', [Validators.required]),
    //   emailFormControl : new FormControl('', [
    //     Validators.required,
    //     Validators.email,
    //   ]),
    //   telFormControl : new FormControl('', [Validators.required]),
    //   carNumberFormControl : new FormControl('', [Validators.required]),
    //   bandCarFormControl : new FormControl('', [Validators.required]),
    //   modelCarFormControl : new FormControl('', [Validators.required]),
    //   bandStoreFormControl : new FormControl('', [Validators.required]),
    //   addressStoreFormControl : new FormControl('', [Validators.required]),
    //   postalCarFormControl : new FormControl('', [Validators.required]),
    //   colorCarFormControl : new FormControl('', [Validators.required]),
    // });
  }
  messageError = '';

  firstNameFormcontrol = new FormControl('', [Validators.required]);
  lastNameFormcontrol = new FormControl('', [Validators.required]);
  genderFormControl = new FormControl('ชาย', [Validators.required]);
  // emailFormControl = new FormControl('', [
  //   Validators.required,
  //   Validators.email,
  // ]);
  emailFormControl = new FormControl('', []);
  telFormControl = new FormControl('', [Validators.required, Validators.pattern(/^0[0-9]{9}$/)]);
  carNumberFormControl = new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9ก-๙]+$/)]);
  provinceFormControl = new FormControl('', [Validators.required]);

  bandCarFormControl = new FormControl('', []); //updateValidators
  modelCarFormControl = new FormControl('', []); //updateValidators
  colorCarFormControl = new FormControl('', []); //updateValidators

  bandTyreFormControl = new FormControl('Toyo', [Validators.required]); //updateValidators
  dateTyre = new FormControl('', [Validators.required]); //updateValidators
  locationStoreFormControl = new FormControl({ value: '', disabled: true }, [Validators.required]); //updateValidators
  provinceStoreMainFormControl = new FormControl('', [Validators.required]); //updateValidators
  locationStoreValidate = true;
  provinceStoreMainValidate = true;

  bandStoreFormControl = new FormControl('', []); //updateValidators
  addressStoreFormControl = new FormControl('', []); //updateValidators
  postalCarFormControl = new FormControl('', []); //updateValidators

  conditionFormControl = new FormControl('1', [Validators.required]); // Default value: 'ยินดีรับ'
  agreementAcceptFormControl = new FormControl('1', [Validators.required]); // Default value: 'ยินดีรับ'
  provinceStoreFormControl = new FormControl('', []);
  // franchiseCarFormControl = new FormControl('', []);
  urlImg?: string = '';

  form = {
    firstName: '',
    lastName: '',
    gender: 'ชาย',
    email: '',
    tel: '',
    carNumber: '',

    province: '',
    newCar: false,
    bandCar: '',
    modelCar: '',
    colorCar: '',
    bandTyre: 'Toyo',
    dateTyre: Date(),
    provinceMain: '',
    locationStore: '',
    storeList: false,
    bandStore: '',
    addressStore: '',
    provinceCar: '',
    PostalCar: '',
    // franchiseCar: '',
    rating: '',
    file: '',
    didYouKnow: [],
    accessMedia: [],
    warranty_term_accept: false,
    agreementAccept: true,
    condition: '',
  };
  readonly dialog = inject(MatDialog);
  readonly router = inject(Router);

  openDialog(value: string) {
    if (!(this.agreementAcceptFormControl.value == '1' && value == 'confirm')) {
      const dialogRef = this.dialog.open(ConditionWarrantyComponent, {
        width: '450px',
        data: { clickForm: value },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.agreementAcceptFormControl.setValue('1');
        }
        this.loggingService.log(this.agreementAcceptFormControl.value);
      });
    }
  }
  openDialogSucess() {
    const dialogRef = this.dialog.open(SuccessComponent, {
      width: '450px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loggingService.log(`Dialog result: ${result}`);
    });
  }
  openDialogPolicy() {
    const dialogRef = this.dialog.open(PolicyDialogComponent, {
      width: '450px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loggingService.log(`Dialog result: ${result}`);
    });
  }
  openDialogAdvance() {
    const dialogRef = this.dialog.open(ConditionWarrantyAdvanceComponent, {
      width: '450px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loggingService.log(`Dialog result advance: ${result}`);
    });
  }
  openDialogValidate() {
    const dialogRef = this.dialog.open(ValidDialogComponent, {
      width: '450px',
      data: {
        firstName: this.firstNameFormcontrol.valid,
        lastName: this.lastNameFormcontrol.valid,
        phone: this.telFormControl.valid,
        phonePattern: this.telFormControl.hasError('pattern'),
        carNumber: this.carNumberFormControl.valid,
        province: this.provinceFormControl.valid,
        bandCar: this.bandCarFormControl.valid,
        modelCar: this.modelCarFormControl.valid,
        colorCar: this.colorCarFormControl.valid,

        dateTyre: this.dateTyre.valid,
        locationStore: this.locationStoreValidate ? this.locationStoreFormControl.valid : true,
        provinceStoreMain: this.provinceStoreMainValidate ? this.provinceStoreMainFormControl.valid : true,
        bandStore: this.bandStoreFormControl.valid,
        addressStore: this.addressStoreFormControl.valid,
        provinceStore: this.provinceStoreFormControl.valid,
        postal: this.postalCarFormControl.valid,

        // franchiseCar: this.franchiseCarFormControl.valid,

        img: this.successFile,
        agreementAccept: this.agreementAcceptFormControl.valid,
        checkPatternEmail: !this.checkPatternEmail,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loggingService.log(`Dialog result: ${result}`);
    });
  }
  getChannelName(channel: string): string {
    const channelNames: { [key: string]: string } = {
      google: 'Google',
      twitter: 'Twitter',
      radio: 'สื่อวิทยุ',
      facebook: 'Facebook',
      youtube: 'YOUTUBE',
      printMedia: 'สื่อสิ่งพิมพ์',
      instagram: 'Instagram',
      line: 'LINE',
      tiktok: 'TikTok',
      billboard: 'Billboard',
      tv: 'TV',
    };
    return channelNames[channel] || '';
  }

  getChannelNameDidyouknow(channel: string): string {
    const channelNames: { [key: string]: string } = {
      google: 'Google',
      twitter: 'Twitter',
      radio: 'สื่อวิทยุ',
      facebook: 'Facebook',
      youtube: 'YOUTUBE',
      printMedia: 'สื่อสิ่งพิมพ์',
      instagram: 'Instagram',
      line: 'LINE',
      tiktok: 'TikTok',
      billboard: 'Billboard',
      tv: 'TV',
      friend: 'เพื่อนแนะนำ',
      store: 'ร้านค้าแนะนำ',
    };
    return channelNames[channel] || '';
  }
  selectedChannels: { [key: string]: boolean } = {
    google: false,
    twitter: false,
    radio: false,
    facebook: false,
    youtube: false,
    printMedia: false,
    instagram: false,
    line: false,
    tiktok: false,
    billboard: false,
    tv: false,
  };
  selectedChannelsDidyouknow: { [key: string]: boolean } = {
    google: false,
    twitter: false,
    billboard: false,
    facebook: false,
    youtube: false,
    radio: false,
    friend: false,
    printMedia: false,
    instagram: false,
    line: false,
    tiktok: false,
    tv: false,
    store: false,
  };
  formGroupData = new FormWarranty();

  currentRating = 5;
  rating = 3;
  hoverRating = 3;
  redPlate = false;
  showService = false;

  changeService(value: boolean) {
    this.form.storeList = value;
    this.showService = value;
    this.updateValidatorsService(value);
  }
  updateValidatorsService(value: boolean): void {
    this.loggingService.warn('FUNC | updateValidatorsService', value);
    if (value) {
      this.locationStoreFormControl.enable();

      this.locationStoreFormControl.clearValidators();
      this.provinceStoreMainFormControl.clearValidators();

      this.bandStoreFormControl.setValidators([Validators.required]);
      this.addressStoreFormControl.setValidators([Validators.required]);
      this.postalCarFormControl.setValidators([Validators.required]);
      this.provinceStoreFormControl.setValidators([Validators.required]);
      this.locationStoreFormControl.disable();
      this.provinceStoreMainFormControl.disable();
      this.locationStoreFormControl.patchValue('');
      this.provinceStoreMainFormControl.patchValue('');
      this.locationStoreValidate = false;
      this.provinceStoreMainValidate = false;
      // this.franchiseCarFormControl.setValidators([Validators.required]);
    } else {
      this.provinceStoreMainFormControl.enable();
      this.locationStoreFormControl.disable();

      this.locationStoreFormControl.setValidators([Validators.required]);
      this.provinceStoreMainFormControl.setValidators([Validators.required]);
      this.locationStoreValidate = true;
      this.provinceStoreMainValidate = true;

      this.bandStoreFormControl.clearValidators();
      this.addressStoreFormControl.clearValidators();
      this.postalCarFormControl.clearValidators();
      this.provinceStoreFormControl.clearValidators();
      // this.franchiseCarFormControl.clearValidators();
    }
    this.locationStoreFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.provinceStoreMainFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.bandStoreFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.addressStoreFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.postalCarFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.provinceStoreFormControl.updateValueAndValidity(); // Re-evaluate validation
    // this.franchiseCarFormControl.updateValueAndValidity(); // Re-evaluate validation
  }
  changeRedPlate(value: boolean) {
    this.redPlate = value;
    this.updateValidatorsRedPlate(value);
  }
  changeAgreementAccept(value: boolean) {
    this.form.agreementAccept = value;
  }
  updateValidatorsRedPlate(value: boolean): void {
    if (value) {
      this.bandCarFormControl.setValidators([Validators.required]);
      this.modelCarFormControl.setValidators([Validators.required]);
      this.colorCarFormControl.setValidators([Validators.required]);
      // this.carNumberFormControl.clearValidators();
    } else {
      this.bandCarFormControl.clearValidators();
      this.modelCarFormControl.clearValidators();
      this.colorCarFormControl.clearValidators();
      // this.carNumberFormControl.setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9ก-๙]+$/)]);
    }
    this.bandCarFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.modelCarFormControl.updateValueAndValidity(); // Re-evaluate validation
    this.colorCarFormControl.updateValueAndValidity(); // Re-evaluate validation
    // this.carNumberFormControl.updateValueAndValidity(); // Re-evaluate validation
  }

  changeRating(value: number) {
    this.currentRating = 5;
    this.loggingService.log('Rating updated to:', this.currentRating);
  }
  onClickResult!: ClickEvent;
  onHoverRatingChangeResult!: HoverRatingChangeEvent;
  onRatingChangeResult!: RatingChangeEvent;

  onClick = ($event: ClickEvent) => {
    this.onClickResult = $event;
    this.rating = $event.rating;
    this.loggingService.log(this.rating);
  };

  onRatingChange = ($event: RatingChangeEvent) => {
    this.onRatingChangeResult = $event;
    this.rating = $event.rating;
    this.loggingService.log(this.rating);
  };
  // hoverRating = 0;
  // hoverRating = 0;
  textHoverStyle = 0; // สำหรับใช้ปรับค่าของ tooltip

  onHoverRatingChange($event: any) {
    this.hoverRating = $event.hoverRating;
  }
  showExtraClass = true;

  warrantyService = inject(FormApiService);
  provinces: any[] = [];
  centerServices: any[] = [];
  centerServicesFranchise: any[] = [];

  ngOnInit() {
    this.warrantyService
      .getProvincesLists()
      .pipe(
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((data) => {
        // this.loggingService.log("promotiondata", data);
        this.provinces = data;
        this.options = data;
      });

    this.filteredOptions = this.provinceFormControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );
    this.filteredProvinceStoreOptions = this.provinceStoreFormControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );
    this.filteredProvinceStoreMainOptions = this.provinceStoreMainFormControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );

    this.warrantyService
      .getCenterService('grip', '')
      .pipe(
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((data) => {
        this.loggingService.log('centerServicesFranchise', data);
        this.centerServicesFranchise = data;
      });

    // this.filterFranchiseOptions = this.franchiseCarFormControl.valueChanges.pipe(
    //   startWith(''),
    //   map((value) => this._filterFranchise(value || ''))
    // );
    this.filterLocationStoreOptions = this.locationStoreFormControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterLocationStore(value || ''))
    );
  }
  haveImg = true;
  successFile = false;
  allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg'];
  fileType = '';
  maxFileSizeMB = 10; // Maximum file size in MB
  onFileChange(event: any) {
    this.successFile = false;
    this.urlImg = '';
    const file = event.target.files[0];
    this.fileType = file.type;
    this.fileInfo = null;
    const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB
    this.loggingService.log('fileSizeMB', fileSizeMB);
    this.loggingService.log('file', file);
    if (!file) {
      this.loggingService.log('No file selected');
      return;
    }

    if (this.isValidFileType(file.type) && fileSizeMB < this.maxFileSizeMB) {
      this.statusUploadImg = true;
      this.imgFail = false;
      this.successFile = true;
      this.selectedFile = file;

      //for reader on mobile
      // const reader = new FileReader();
      // reader.onload = (e: any) => {
      //   this.urlImg = e.target.result; // Set image URL
      //   this.loggingService.log('Image URL:', this.urlImg);
      // };
      // reader.readAsDataURL(file);

      this.uploadFile();
    } else {
      this.loggingService.error('Invalid file type. Only PDF, JPG, and JPEG are allowed.');
      this.imgFail = true;
      this.successFile = false;
      this.clearFileInput(event);
    }
  }
  clearFileInput(event: any) {
    this.selectedFile = null;
    event.target.value = '';
  }
  // Validate file type
  isValidFileType(fileType: string): boolean {
    return this.allowedFileTypes.includes(fileType.toLowerCase());
  }

  imgFail = false;
  statusUploadImg?: boolean = false;
  selectedFile: File | null = null;
  fileInfo: any = null;
  pdfFile = false;

  uploadFile() {
    this.loggingService.log('uploadFile');
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('tw_file', this.selectedFile, this.selectedFile.name);

      this.warrantyService
        .postImage(formData)
        .pipe(
          catchError((error) => {
            this.loggingService.error(error);
            this.imgFail = true;
            return throwError(() => error);
          })
        )
        .subscribe((data) => {
          this.loggingService.log('API Response:', data);
          this.pdfFile = false;

          if (data.ok === 1) {
            this.fileInfo = data.data;
            this.fileType = this.selectedFile?.type || '';

            // อัพเดตค่า `pdfFile` และ `urlImg`
            if (this.fileType === 'application/pdf') {
              this.pdfFile = true;
              this.urlImg = ''; // ล้างค่า urlImg ถ้าเป็น PDF
            } else {
              this.pdfFile = false;
              this.urlImg = this.fileInfo.url;
            }

            this.statusUploadImg = false;
            this.haveImg = true;
            this.cdr.detectChanges();

            this.loggingService.log('pdfFile:', this.pdfFile);
            this.loggingService.log('imgFail:', this.imgFail);
            this.loggingService.log('urlImg:', this.urlImg);
          } else {
            this.loggingService.error('Upload failed:', data);
            this.imgFail = true;
          }
        });
    } else {
      this.loggingService.log('No file selected');
    }
  }

  onSubmit() {
    this.validateAllControls();
    this.validatePhoneNumber();
    if (this.form.email != '') {
      this.validateEmail();
    } else {
      this.checkPatternEmail = false;
    }
    if (this.showService) {
      this.validatePostalCode();
    }
    const selected = Object.keys(this.selectedChannels)
      .filter((channel) => this.selectedChannels[channel])
      .map((channel) => this.getChannelName(channel));
    const channels = selected.join(', ');

    const selectedDidyouknow = Object.keys(this.selectedChannelsDidyouknow)
      .filter((channel) => this.selectedChannelsDidyouknow[channel])
      .map((channel) => this.getChannelNameDidyouknow(channel));
    const channelsDidyouknow = selectedDidyouknow.join(', ');
    if (this.urlImg != '') {
      this.haveImg = true;
    } else {
      this.haveImg = false;
    }
    // Log the selected channels
    // this.loggingService.log('Selected Channels:', selected.join(', '));

    // this.loggingService.log('Selected Channels:', selected.join(', '));
    // this.loggingService.log('firstNameFormcontrol',this.firstNameFormcontrol.valid);
    // this.loggingService.log('lastNameFormcontrol',this.lastNameFormcontrol.valid )
    // this.loggingService.log('genderFormControl',this.genderFormControl.valid )
    // this.loggingService.log('emailFormControl',this.emailFormControl.valid )
    // this.loggingService.log('telFormControl',this.telFormControl.valid )
    // this.loggingService.log('carNumberFormControl',this.carNumberFormControl.valid )
    // this.loggingService.log('bandCarFormControl',this.bandCarFormControl.valid )
    // this.loggingService.log('modelCarFormControl',this.modelCarFormControl.valid )
    // this.loggingService.log('colorCarFormControl',this.colorCarFormControl.valid )
    // // this.loggingService.log('locationStore',this.locationStore.valid )
    // this.loggingService.log('bandTyreFormControl',this.bandTyreFormControl.valid )
    // this.loggingService.log('dateTyre',this.dateTyre.valid )
    // this.loggingService.log('bandStoreFormControl',this.bandStoreFormControl.valid )
    // this.loggingService.log('addressStoreFormControl',this.addressStoreFormControl.valid )
    // this.loggingService.log('postalCarFormControl',this.postalCarFormControl.valid )
    // this.loggingService.log('conditionFormControl',this.conditionFormControl.value)
    if (
      this.firstNameFormcontrol.valid &&
      this.lastNameFormcontrol.valid &&
      this.genderFormControl.valid &&
      this.emailFormControl.valid &&
      this.telFormControl.valid &&
      this.carNumberFormControl.valid &&
      this.provinceFormControl.valid &&
      this.bandCarFormControl.valid &&
      this.modelCarFormControl.valid &&
      this.colorCarFormControl.valid &&
      this.bandTyreFormControl.valid &&
      this.dateTyre.valid &&
      this.provinceStoreFormControl.valid &&
      (this.locationStoreValidate ? this.locationStoreFormControl.valid : true) &&
      (this.provinceStoreMainValidate ? this.provinceStoreMainFormControl.valid : true) &&
      this.bandStoreFormControl.valid &&
      this.addressStoreFormControl.valid &&
      this.postalCarFormControl.valid &&
      // this.franchiseCarFormControl.valid &&
      this.agreementAcceptFormControl.valid &&
      !this.checkPatternEmail
    ) {
      this.loggingService.log('Form Submitted:', this.bandCarFormControl.value);
      this.loggingService.log('dateTyre', this.form.dateTyre);
      // this.loggingService.log('dateTyre', this.formGroup.value);
      const formattedDate = formatDate(this.form.dateTyre, 'dd/MM/yyyy', this.locale); // Use the desired format
      this.loggingService.log(formattedDate);

      this.loggingService.log('this.form.newCar', this.form.newCar);
      this.loggingService.log('this.form.storeList', this.form.storeList);
      this.loggingService.log('this.form.agreementAccept', this.form.agreementAccept);
      //(GRIP|NITTO|NANGANG|TOYO)
      this.formGroupData.warranty_type = 'GRIP';
      this.formGroupData.name = this.form.firstName;
      this.formGroupData.surname = this.form.lastName;
      this.formGroupData.sex = this.form.gender;
      this.formGroupData.email = this.form.email;
      this.formGroupData.mobile_no = this.form.tel;
      this.formGroupData.car_id = this.form.carNumber;
      this.formGroupData.car_province = this.form.province;
      this.formGroupData.car_new = this.form.newCar ? 1 : 0;
      this.formGroupData.car_new_brand = this.form.bandCar;
      this.formGroupData.car_new_model = this.form.modelCar;
      this.formGroupData.car_new_color = this.form.colorCar;
      this.formGroupData.tire_brand = this.form.bandTyre;
      this.formGroupData.tire_install_date = formattedDate;
      this.formGroupData.tire_service_center_name = this.form.locationStore;
      this.formGroupData.tire_from_store = this.form.storeList ? 1 : 0;
      this.formGroupData.tire_store_name = this.form.bandStore;
      this.formGroupData.tire_store_address = this.form.addressStore;
      this.formGroupData.tire_store_province = this.form.provinceCar;
      this.formGroupData.tire_store_postcode = this.form.PostalCar;
      // this.formGroupData.tire_store_by_service_center_name = this.form.franchiseCar;
      this.formGroupData.rate_the_service = this.rating.toString();
      this.formGroupData.slip_image = this.fileInfo.url;
      this.formGroupData.did_you_know = channelsDidyouknow;
      this.formGroupData.access_media = channels;

      // if (this.form.agreementAccept) {
      //   this.formGroupData.warranty_term_accept = 1;
      // } else {
      //   this.formGroupData.warranty_term_accept = 0;
      // }
      // this.formGroupData.warranty_term_accept = this.agreementAcceptFormControl.value? 1:0;
      this.formGroupData.warranty_term_accept = 1;

      if (this.conditionFormControl.value == '1') {
        this.formGroupData.agreement_accept = 1;
      } else {
        this.formGroupData.agreement_accept = 0;
      }

      this.loggingService.log('payload', this.formGroupData);
      this.loggingService.log('agreementAccept', this.form.agreementAccept);
      if (this.form.agreementAccept) {
        this.warrantyService
          .postForm(this.formGroupData)
          .pipe(
            catchError((error) => {
              this.loggingService.error(error);
              return throwError(() => error);
            })
          )
          .subscribe((data) => {
            this.loggingService.log(' ', data);
            if (data.ok === 0 && data.error === 1) {
              this.ngZone.run(() => {
                this.messageError =
                  'ขออภัย ทะเบียนรถนี้ได้มีการลงทะเบียนไปแล้ว เมื่อ ' +
                  data.data.register_date_at +
                  ' โดยจะสามารถลงทะเบียนได้หลังจากวันที่ ' +
                  data.data.after_date_at;
              });
              this.cdr.detectChanges();

              this.loggingService.log('error ', this.messageError);
            } else if (data.ok === 1) {
              this.router.navigate(['/thankyou'], {
                skipLocationChange: true,
                // replaceUrl: true,
              });
            }
          });
      } else {
        this.loggingService.log('กรุณายอมรับในเงื่อนไขการรับประกัน');
      }
    } else {
      this.openDialogValidate();

      this.loggingService.error('Form is invalid');
    }
    // if () {
    //   this.warrantyService.postForm(this.formGroupData).pipe(catchError((error) => {
    //     this.loggingService.error(error)
    //     return throwError(() => error)
    //   }),
    //   ).subscribe(data => {
    //     this.loggingService.log("promotiondata", data);
    //     // this.centerServices = data

    //   });
    // }
  }

  validateAllControls() {
    [
      // this.firstNameFormcontrol,
      // this.lastNameFormcontrol,
      // this.genderFormControl,
      // // this.emailFormControl,
      // this.telFormControl,
      // this.carNumberFormControl,
      // this.provinceFormControl,

      // this.bandCarFormControl,
      // this.modelCarFormControl,
      // this.colorCarFormControl,

      // this.bandTyreFormControl,
      // this.dateTyre,
      this.locationStoreFormControl,
      // this.provinceStoreMainFormControl,
      // this.bandStoreFormControl,
      // this.addressStoreFormControl,
      // this.postalCarFormControl,
      // this.conditionFormControl,
      // this.agreementAcceptFormControl,
    ].forEach((control) => {
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  options: any[] = [];
  filteredOptions?: Observable<any[]>;
  filteredProvinceStoreOptions?: Observable<any[]>;
  filteredProvinceStoreMainOptions?: Observable<any[]>;
  // filterFranchiseOptions?: Observable<any[]>;
  filterLocationStoreOptions?: Observable<any[]>;

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    this.loggingService.log(
      'this.options.filter((option) => option.name_th.toLowerCase().includes(filterValue)',
      this.options.filter((option) => option.name_th.toLowerCase().includes(filterValue))
    );
    return this.options.filter((option) => option.name_th.toLowerCase().includes(filterValue));
  }
  // private _filterFranchise(value: string): any[] {
  //   const filterValue = value.toLowerCase();

  //   return this.centerServicesFranchise.filter((option) => option.name.toLowerCase().includes(filterValue));
  // }
  private _filterLocationStore(value: string): any[] {
    const filterValue = value.toLowerCase();
    this.loggingService.log(this.centerServices.filter((option) => option.name.toLowerCase().includes(filterValue)));
    return this.centerServices.filter((option) => option.name.toLowerCase().includes(filterValue));
  }

  onClickFilterProvinceFormControl() {
    // บังคับให้ autocomplete แสดงค่าทั้งหมดเมื่อกดครั้งแรก
    if (!this.provinceFormControl.value) {
      this.provinceFormControl.setValue(' ');
      setTimeout(() => {
        this.provinceFormControl.setValue('');
      });
    }
  }
  onClickFilterProvinceStoreFormControl() {
    // บังคับให้ autocomplete แสดงค่าทั้งหมดเมื่อกดครั้งแรก
    if (!this.provinceStoreFormControl.value) {
      this.provinceStoreFormControl.setValue(' ');
      setTimeout(() => {
        this.provinceStoreFormControl.setValue('');
      });
    }
  }
  onClickFilterProvinceStoreMainFormControl() {
    // บังคับให้ autocomplete แสดงค่าทั้งหมดเมื่อกดครั้งแรก
    if (!this.provinceStoreMainFormControl.value) {
      this.provinceStoreMainFormControl.setValue(' ');
      setTimeout(() => {
        this.provinceStoreMainFormControl.setValue('');
      });
    }
  }
  onClickFilterLocationStoreFormControl() {
    // บังคับให้ autocomplete แสดงค่าทั้งหมดเมื่อกดครั้งแรก
    if (!this.locationStoreFormControl.value) {
      this.locationStoreFormControl.setValue(' ');
      setTimeout(() => {
        this.locationStoreFormControl.setValue('');
      });
    }
  }
  onSelectProvinceStoreMain(event: any) {
    // this.form.provinceMain = event.option.value; // อัปเดตค่าที่เลือกไปยัง form
    this.loggingService.log('event.name_th', event);
    this.warrantyService
      .getCenterService('grip', this.form.provinceMain)
      .pipe(
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((data) => {
        // this.loggingService.log("promotiondata", data);
        this.centerServices = data;
      });
    this.loggingService.log('Selected Province:', this.form.provinceMain);
    this.locationStoreFormControl.setValue('');

    this.locationStoreFormControl.enable();
  }
}
